const API_ENDPOINTS = {
  WORKSPACE: {
    workspace: "workspaces/",
    workspaceVersions: "workspace_versions/",
    version: "workspace_versions/workspaceid/",
    project: "project",
     testcasepriorities:"test_case_priorities/",
     testcasestatuses:"test_case_statuses/",
  },

  DEFECTLOG: {
    defectLog: "defectlog",
    assigneddefects:"defectlog/assigneddefects",
    myDefectQueue: "defectlog/my-queue",
    export:"defectlog/export",
    folderTree: "defectlog/folder-tree",
    linkedTestCases: (defectId: number | string) => `defectlog/${defectId}/linked-test-cases`,
    references: (defectId: number | string) => `defectlog/${defectId}/references`,
    externalLinks: (defectId: number | string) => `defectlog/${defectId}/external-links`,
    pushGitHub: (defectId: number | string) => `defectlog/${defectId}/push-github`,
    pushMonday: (defectId: number | string) => `defectlog/${defectId}/push-monday`,
    githubCollaborators: (configId: number | string) => `settings/integrations/${configId}/github_collaborators`,
    defectTags: "defect_tags/",
  },

  AUTH: {
    login: "login",
    logout: "logout",
    user: "user/",
    useDetails: "user/userdetail",
    getUsers: "user/getusers",
    adminUserList: "user/userlist",
    sessions: "sessions",
    servers: "servers",
    usePreference: "user_preferences",
    checkEmailAlreadyRegister: "onboarding/checkemail/",
    validateBussinessEmail: "onboarding/validbusinessemail/",
    checkWebaddressAvail: "onboarding/checkwebaddressavailable/",
    checkCompanyNameAvail: "onboarding/checkcompanyname/",
    onboarding: "onboarding/",
    checkEmailVerified: "onboarding/checkEmailVerified/",
    checkAccountVerifed: "onboarding/checkAccountApproval/",
    resendEmail: "onboarding/resendemail",
    sendOtp: "onboarding/send-otp",
    verifyOtp: "onboarding/verify-otp",
    resetPassword: "onboarding/forgotpassword/",
    // Authenticated onboarding wizard (post-verification multi-step flow)
    wizardState: "onboarding-wizard/state",
    wizardCheckOrgName: (name: string) => `onboarding-wizard/check-org-name?name=${encodeURIComponent(name)}`,
    wizardOrganization: "onboarding-wizard/organization",
    wizardProject: "onboarding-wizard/project",
    wizardInvites: "onboarding-wizard/invites",
    wizardComplete: "onboarding-wizard/complete",
    changepassword: "user/changepassword",
    approveUser: (id: number) => `user/approve/${id}`,
    demoRequests: "demorequest",
  },

  DASHBOARD: {
    browserList: "test_devices/browserlist/",
    filteredTestCases: "test_cases/filteredtestcases/",
    testCaseStatus: "test_cases/testcasestatus/",
    defectStatus: "defectlog/defectstatus/",
    activeTestCaseRun: "test_cases/activetestcaserun/",
    recentlyFailedTestCases: "test_cases/recentlyfailedtestcase/",
    testPlanSchedule: "schedule_test_plans/filteredtestplans/",
  },
COMMENT:{
    comments: "comments",
},
HISTORY:{
    history: "history",
},
  TESTCASE: {
    testCase: "test_cases/",
    testCaseStats: "test_cases/stats",
    testCaseLinkedEntities: (id: number | string) => `test_cases/${id}/linked_entities`,
    testCaseRunHistory: (id: number | string) => `test_cases/${id}/run_history`,
    testCaseCycleRuns: (id: number | string) => `test_cases/${id}/cycle_runs`,
    testCaseRequirements: (id: number | string) => `test_cases/${id}/requirements`,
    testCaseRequirementLink: (id: number | string, reqId: number | string) =>
      `test_cases/${id}/requirements/${reqId}`,
    testCasePlans: "test_cases/test_plans",
    allTestCases: "test_cases/filter/2",
    automatedTest: "test_cases/filter/13",
    manualTest: "test_cases/filter/15",
    performanceTest: "test_cases/filter/14",
    testTags: "testcase_tags/",
    testCaseTypes: "test_case_types/",
    testCasePriorities: "test_case_priorities/",
    priorities: "priorities/",
    testCaseStatuses: "test_case_statuses/",
    testData: "test_data",
    testRequirement: "testrequirement/",
    testCaseTags: "testcase_tags/",
    validateURL: "test_cases/validateUrls/",
    checkNameExists: "test_cases/checkNameExists",
    integrationSettings: "settings/integrations",
    testCaseActivity: "history",
    testCaseComments: "comments",
    testSteps: "test_steps",
    extensionStatus: "kibbutz/actions",
    naturalTextActions: "natural_text_actions",
    forLoopConditions: "for_loop_conditions",
    testCaseResults: "test_case_results",
    testCaseFolder: "test_case_folder",
    moveItems: "test_case_folder/move-items",
    subFolder: "test_case_folder/createsubfolder",
    createBulkFolder:"test_case_folder/createbulkfolders",
    fetchRestResponse: "test_steps/fetch_rest_response",
    dryTestPlan: "dry_test_plans",
    testDataDrivenResults: "test_case_data_driven_results",
    defaultDataGenerators: "default_data_generators",
  },
TESTSTEP:{
    bulkUpdateTestSteps: "test_steps/bulk_update",
},
  TESTPLAN: {
    testPlan: "test_plans",
    testPlanCases: "test_plan_cases",
    testPlanResult: "test_plan_results",
    testPlanTags: "test_plan_tags",
    testPlanSchedule: "schedule_test_plans",
    testSuite: "test_suites",
    testDevice: "test_devices",
    checkNameExists: "test_plans/checkNameExists",
    myWorkItems: "workitems",
    myQueue: "my-queue",
  },

  TESTRESULTS:{
    testPlanResults:"test_plan_results",
    testCaseResults:"test_case_results",
    testSuiteResults:"test_suite_results",
    testDeviceResults:"test_device_results",
    testStepResults: "test_step_results",

  },

  TESTSUITE:{
   testSuite: "test_suites",
   testSuiteTags: "test_suite_tags",
   testCase: "test_cases",
   checkNameExists: "test_suites/checkNameExists",
  },

  RECORDER: {
    testSteps: "os_recorder/v2/test_steps",
    naturalTextActions: "os_recorder/v2/nlp_templates",
    uiIdentifier: "os_recorder/ui_identifiers",
    testData: "os_recorder/test_data",
    bulkUpdateStepsProps: "os_recorder/v2/test_steps/bulk_update_properties",
    bulkUpdateSteps: "os_recorder/v2/test_steps/bulk_update",
    bulkDeleteSteps: "os_recorder/v2/test_steps/bulk_delete",
  },
TESTDATA:{
    testData: "test_data",
   importFieldNames: "test_data/import_field_names",
   checkNameExists: "test_data/checkNameExists",
},
  AGENT: {
    agentURL: "settings/agents",
    agentDevices: "settings/agent_devices",
    adhocConfig: "adhoc_run_configurations",
  },

  PLATFORMS: {
    osVersion: "platforms",
  },

  IMPORTEXPORT: {
    workspaces: "workspaces/importexport",
    backup: "settings/backups",
    export: "settings/backups/export",
  },

  ELEMENTS: {
    elements: "elements",
    elementFilter: "elements/filter/",
    elementScreenName: "elements_screen_name",
    checkEmptyElement: "elements/empty/",
    linkedEntities: (id: number | string) => `elements/${id}/linked_entities`,
    promotePrimaryLocator: (id: number | string) => `elements/${id}/primary_locator`,
  },

  ACTIVITY: {
    comments: "comments",
  },

  USER: {
    assignee: "user/getassignee",
    getUsers: "user/getusers",
    allActiveUsers: "user/allactiveusers",
    testMemberList: "user/teammemberslist/",
    
    getUserRoles: "userroles/list",
    getRolePermissions: (roleId: number) => `roles/${roleId}/permissions`,
    getUserOrgs: "user/orgs",
  },

  ENV: {
    environments: "environments",
  },
  REQUIREMENT: {
    requirement: "requirement_types/",
    requirementTags: "requirement_tags",
    requirementLinks: (id: number | string) => `testrequirement/${id}/links`,
    checkNameExists: "testrequirement/checkNameExists",
    // MVP (architecture-review-v1 Table B)
    approve: (id: number | string) => `testrequirement/${id}/approve`,
    reject: (id: number | string) => `testrequirement/${id}/reject`,
    approvalStatus: (id: number | string) => `testrequirement/${id}/approval-status`,
    trace: (id: number | string) => `testrequirement/${id}/trace`,
    coverageGaps: "testrequirement/coverage/gaps",
    coverageSummary: "testrequirement/coverage/summary",
    // Group B: audit history, unified activity timeline, dashboard rollup
    audit: (id: number | string) => `testrequirement/${id}/audit`,
    activity: (id: number | string) => `testrequirement/${id}/activity`,
    dashboard: "testrequirement/dashboard",
    bulk: "testrequirement/bulk",
    bulkCreate: "testrequirement/bulk-create",
    import: "testrequirement/import",
    export: "testrequirement/export",
  },

  AI: {
    generateTests: "api/ai/generate/tests",
    cancelTests: "api/ai/generate/cancel",
    generateAutomationSteps: "api/ai/generate/automation-test-steps",
    generateManualSteps: "api/ai/generate/manual-test-steps",
    generateRequirements: "api/ai/generate/requirements",
    promptSuggestions: "api/ai/generate/suggestions",
    generateTestData: "api/ai/generate/test-data",
    /** Background generation job persistence (issue #1876 Phase 2) */
    generationJobsActive: "api/ai/generation-jobs/active",
    generationJob: "api/ai/generation-jobs",
    /** @deprecated Use SSE endpoint for defect suggestions instead */
    suggestDefect: "api/ai/suggest-defect",
    stream: "api/sse/ai-stream",
    defectStream: "api/sse/defect-stream",
    startCrawl: "api/ai/crawl/start",
    crawlAuth: "api/ai/crawl/auth",
    crawlConfirm: "api/ai/crawl/confirm",
    crawlTitles: "api/ai/crawl/titles",
    crawlSteps: "api/ai/crawl/steps",
    crawlContinue: "api/ai/crawl/continue",
    siteSyncStatus: "api/ai/site-sync",
    siteSyncList: "api/ai/site-sync/list",
    siteSyncStart: "api/ai/site-sync/start",
    siteSyncAuth: (id: number | string) => `api/ai/site-sync/${id}/auth`,
    siteSyncResync: (id: number | string) => `api/ai/site-sync/${id}/resync`,
    siteSyncCancel: (id: number | string) => `api/ai/site-sync/${id}/cancel`,
    siteSyncPages: (id: number | string) => `api/ai/site-sync/${id}/pages`,
    siteSyncJourneys: (id: number | string) => `api/ai/site-sync/${id}/journeys`,
    siteSyncTestAuth: "api/ai/site-sync/test-auth",
  },

  INTEGRATION:{
    fetchJiraProjects:"api/integrations/jira/projects",
    fetchJiraIssues:"api/integrations/jira/issues",
  },
  ATTACHMENT:{
    attachments:"attachments",
    rehomeDefect: "attachments/rehome-defect",
  },

  UPLOADS: {
    uploads: "uploads",
    uploadVersions: "upload_versions",
    download: (versionId: number | string) => `upload_versions/${versionId}/download`,
  },

  MOBILE_APPS: {
    apps: "api/v1/mobile/apps",
    appById: (id: number | string) => `api/v1/mobile/apps/${id}`,
    upload: "api/v1/mobile/apps/upload",
    uploadSession: "api/v1/mobile/apps/upload/session",
    uploadFinalize: "api/v1/mobile/apps/upload/finalize",
    deleteApp: (id: number | string) => `api/v1/mobile/apps/${id}`,
    deleteVersion: (appId: number | string, versionId: number | string) =>
      `api/v1/mobile/apps/${appId}/versions/${versionId}`,
    pinVersion: (appId: number | string, versionId: number | string) =>
      `api/v1/mobile/apps/${appId}/versions/${versionId}/pin`,
    setDefault: "api/v1/mobile/apps/workspace/default",
    artifactDownload: (artifactId: number | string) =>
      `api/v1/mobile/apps/artifacts/${artifactId}/download`,
  },

  NOTIFICATIONS: {
    list: "notifications",
    unreadCount: "notifications/unread-count",
    markRead: (id: number) => `notifications/${id}/read`,
    markAllRead: "notifications/read-all",
    deleteById: (id: number) => `notifications/${id}`,
    clearAll: "notifications",
    preferences: "notifications/preferences",
    // SSE stream — uses serverURL directly (no basePath), authenticated via cookie
    sseStream: "/api/sse/notifications",
  },

  SUPPORT: {
    tickets: "support/tickets",
    publicTickets: "support/public/tickets",
    ticketById: (id: number | string) => `support/tickets/${id}`,
    ticketMessages: (id: number | string) => `support/tickets/${id}/messages`,
    ticketStatus: (id: number | string) => `support/tickets/${id}/status`,
    ticketSummary: "support/tickets/summary",
    featureRequests: "support/feature-requests",
    featureRequestById: (id: number | string) => `support/feature-requests/${id}`,
    featureRequestVote: (id: number | string) => `support/feature-requests/${id}/vote`,
    featureRequestComments: (id: number | string) => `support/feature-requests/${id}/comments`,
    bugReports: "support/bug-reports",
    bugReportById: (id: number | string) => `support/bug-reports/${id}`,
    bugReportComments: (id: number | string) => `support/bug-reports/${id}/comments`,
  },

  CYCLES: {
    cycles: "cycles",
    releaseFolders: "release_folders",
    configurations: "cycle_configurations",
    screenResolutions: "screen_resolutions",
    configOptions: "config_options",
    myQueue: "cycles/my-queue",
    dashboard: "cycles/dashboard",
    dashboardInsights: "cycles/dashboard/ai-insights",
    dashboardAsk: "cycles/dashboard/ask",
    scopeCut: "cycles/scope-cut",
    inbox: "cycles/inbox",
    inboxArchive: "cycles/inbox/archive",
    soloContext: "cycles/solo-context",
    dismissBanner: "cycles/solo-context/dismiss-banner",
    report: (cycleId: number | string) => `cycles/${cycleId}/report`,
    reportSummary: (cycleId: number | string) => `cycles/${cycleId}/report/summary`,
    reportByTester: (cycleId: number | string) => `cycles/${cycleId}/report/by-tester`,
    reportByConfig: (cycleId: number | string) => `cycles/${cycleId}/report/by-config`,
    reportCoverage: (cycleId: number | string) => `cycles/${cycleId}/report/coverage`,
    reportRisk: (cycleId: number | string) => `cycles/${cycleId}/report/risk`,
    reportSnapshot: (cycleId: number | string) => `cycles/${cycleId}/report/snapshot`,
    reportExport: (cycleId: number | string) => `cycles/${cycleId}/report/export`,
    reportAiSummary: (cycleId: number | string) => `cycles/${cycleId}/report/ai-summary`,
    reportShare: (cycleId: number | string) => `cycles/${cycleId}/report/share`,
    reportShareToken: (cycleId: number | string, tokenId: number | string) =>
      `cycles/${cycleId}/report/share/${tokenId}`,
    reportShareDelete: (cycleId: number | string, tokenId: number | string) =>
      `cycles/${cycleId}/report/share/${tokenId}`,
    reportShareRevoke: (cycleId: number | string, tokenId: number | string) =>
      `cycles/${cycleId}/report/share/${tokenId}/revoke`,
    reportEmailSchedules: (cycleId: number | string) => `cycles/${cycleId}/report/email-schedules`,
    reportEmailSchedule: (cycleId: number | string, scheduleId: number | string) =>
      `cycles/${cycleId}/report/email-schedules/${scheduleId}`,
    publicReport: (token: string) => `api/public/report/${token}`,
    publicReportVerify: (token: string) => `api/public/report/${token}/verify-password`,
    publicReportExecution: (token: string, cycleCaseId: number) => `api/public/report/${token}/executions/${cycleCaseId}`,
    defects: (cycleId: number | string) => `cycles/${cycleId}/defects`,
    participants: (cycleId: number | string) => `cycles/${cycleId}/participants`,
    reassign: (cycleId: number | string) => `cycles/${cycleId}/cases/reassign`,
    referencingCase: (testCaseId: number | string) => `cycles/referencing-case/${testCaseId}`,
    caseVersionCandidates: (testCaseId: number | string) => `cycles/case-version-candidates/${testCaseId}`,
    pushVersionToCycles: (testCaseId: number | string) => `cycles/case-version-candidates/${testCaseId}/push`,
    adoptOwnSlotVersion: (cycleId: number | string, cycleCaseId: number | string) =>
      `cycles/${cycleId}/cases/${cycleCaseId}/adopt-version`,
    orphanedDefects: (cycleId: number | string) => `cycles/${cycleId}/defects/orphaned`,
    defectTransition: (defectId: number | string) => `cycle_defects/${defectId}/transition`,
    defectRebind: (defectId: number | string) => `cycle_defects/${defectId}/rebind`,
    schedules: (cycleId: number | string) => `cycles/${cycleId}/schedules`,
    schedule: (cycleId: number | string, scheduleId: number | string) =>
      `cycles/${cycleId}/schedules/${scheduleId}`,
    schedulePause: (cycleId: number | string, scheduleId: number | string) =>
      `cycles/${cycleId}/schedules/${scheduleId}/pause`,
    scheduleResume: (cycleId: number | string, scheduleId: number | string) =>
      `cycles/${cycleId}/schedules/${scheduleId}/resume`,
    scheduleRunNow: (cycleId: number | string, scheduleId: number | string) =>
      `cycles/${cycleId}/schedules/${scheduleId}/run`,
    scheduleRuns: (cycleId: number | string, scheduleId: number | string) =>
      `cycles/${cycleId}/schedules/${scheduleId}/runs`,
  },

  EXECUTIONS: {
    base: "executions",
    start: "executions/start",
    reexecute: "executions/reexecute",
    attempts: "executions/attempts",
    byId: (id: number | string) => `executions/${id}`,
    step: (id: number | string, stepId: number | string) => `executions/${id}/steps/${stepId}`,
    timer: (id: number | string) => `executions/${id}/timer`,
    attachments: (id: number | string) => `executions/${id}/attachments`,
    attachmentUpload: (id: number | string) => `executions/${id}/attachments/upload`,
    attachment: (id: number | string, attId: number | string) =>
      `executions/${id}/attachments/${attId}`,
    stepComments: (id: number | string, stepId: number | string) =>
      `executions/${id}/steps/${stepId}/comments`,
    comment: (id: number | string, commentId: number | string) =>
      `executions/${id}/comments/${commentId}`,
    defects: (id: number | string) => `executions/${id}/defects`,
    jiraConfigured: "executions/meta/jira-configured",
  },

  LOAD_TESTS: {
    base: "api/load-tests",
    byId: (id: number | string) => `api/load-tests/${id}`,
    executions: (id: number | string) => `api/load-tests/${id}/executions`,
    executionById: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}`,
    executionControl: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}/control`,
    executionCancel: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}/cancel`,
    executionApprove: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}/approve`,
    executionReject: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}/reject`,
    executionReport: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}/report`,
    executionReportExport: (id: number | string, runId: number | string) => `api/load-tests/${id}/executions/${runId}/report/export`,
    auditEvents: (id: number | string) => `api/load-tests/${id}/audit-events`,
    folders: "api/load-tests/folders",
    folderById: (id: number | string) => `api/load-tests/folders/${id}`,
    duplicate: (id: number | string) => `api/load-tests/${id}/duplicate`,
    archive: (id: number | string) => `api/load-tests/${id}/archive`,
    move: (id: number | string) => `api/load-tests/${id}/move`,
    builderConfig: (id: number | string) => `api/load-tests/${id}/builder/config`,
    builderRuntimeConfig: (id: number | string) => `api/load-tests/${id}/builder/config/runtime`,
    builderEnvironmentConfig: (id: number | string) => `api/load-tests/${id}/builder/config/environment`,
    builderTestDataBindings: (id: number | string) => `api/load-tests/${id}/builder/config/test-data-bindings`,
    builderResolveContext: (id: number | string) => `api/load-tests/${id}/builder/config/resolve-context`,
    builderScenarios: (id: number | string) => `api/load-tests/${id}/builder/scenarios`,
    builderScenarioById: (id: number | string, sid: number | string) => `api/load-tests/${id}/builder/scenarios/${sid}`,
    builderScenarioFlows: (id: number | string, sid: number | string) => `api/load-tests/${id}/builder/scenarios/${sid}/flows`,
    builderScenarioFlowById: (id: number | string, sid: number | string, fid: number | string) =>
      `api/load-tests/${id}/builder/scenarios/${sid}/flows/${fid}`,
    builderWorkflowGraph: (id: number | string, sid: number | string) =>
      `api/load-tests/${id}/builder/scenarios/${sid}/workflow/graph`,
    builderWorkflowNodes: (id: number | string, sid: number | string) =>
      `api/load-tests/${id}/builder/scenarios/${sid}/workflow/nodes`,
    builderWorkflowNodeById: (id: number | string, sid: number | string, nid: number | string) =>
      `api/load-tests/${id}/builder/scenarios/${sid}/workflow/nodes/${nid}`,
    builderWorkflowEdges: (id: number | string, sid: number | string) =>
      `api/load-tests/${id}/builder/scenarios/${sid}/workflow/edges`,
    builderWorkflowEdgeById: (id: number | string, sid: number | string, eid: number | string) =>
      `api/load-tests/${id}/builder/scenarios/${sid}/workflow/edges/${eid}`,
    builderPhases: (id: number | string) => `api/load-tests/${id}/builder/phases`,
    builderPhaseById: (id: number | string, pid: number | string) => `api/load-tests/${id}/builder/phases/${pid}`,
    builderValidate: (id: number | string) => `api/load-tests/${id}/builder/validate`,
    builderPreview: (id: number | string) => `api/load-tests/${id}/builder/preview`,
    builderPublish: (id: number | string) => `api/load-tests/${id}/builder/publish`,
    builderVersions: (id: number | string) => `api/load-tests/${id}/builder/versions`,
    builderVersionById: (id: number | string, vid: number | string) => `api/load-tests/${id}/builder/versions/${vid}`,
    builderVersionRestore: (id: number | string, vid: number | string) => `api/load-tests/${id}/builder/versions/${vid}/restore`,
    policies: "api/load-tests/policies",
  },

  ANALYTICS: {
    summary: "api/analytics/summary",
    executionStatus: "api/analytics/execution-status",
    trend: "api/analytics/trend",
    defectStatus: "api/analytics/defect-status",
    defectTrend: "api/analytics/defect-trend",
    runsPerDay: "api/analytics/runs-per-day",
    cycleCoverage: "api/analytics/cycle-coverage",
    topFailing: "api/analytics/top-failing",
    suiteDistribution: "api/analytics/suite-distribution",
    heatmap: "api/analytics/heatmap",
    defectSeverity: "api/analytics/defect-severity",
    defectList: "api/analytics/defect-list",
    recentRuns: "api/analytics/recent-runs",
  },

  ENTERPRISE_REPORTS: {
    automationHealth: "api/enterprise-reports/automation-health",
    testStability: "api/enterprise-reports/test-stability",
    executionEfficiency: "api/enterprise-reports/execution-efficiency",
    environmentHealth: "api/enterprise-reports/environment-health",
    failureAnalysis: "api/enterprise-reports/failure-analysis",
    releaseReadiness: "api/enterprise-reports/release-readiness",
    riskAnalysis: "api/enterprise-reports/risk-analysis",
    scopeChange: "api/enterprise-reports/scope-change",
    teamProductivity: "api/enterprise-reports/team-productivity",
    requirementTraceability: "api/enterprise-reports/requirement-traceability",
    executiveDashboard: "api/enterprise-reports/executive-dashboard",
  },

  ALLURE_REPORT: {
    /** GET /api/reports/:id — check if report exists, returns reportUrl */
    getUrl: (id: number | string) => `api/reports/${id}`,
    /** GET /api/reports/cycle-runs/:runId/cases/:caseResultId/view */
    viewCycleCase: (runId: number | string, caseResultId: number | string) =>
      `api/reports/cycle-runs/${runId}/cases/${caseResultId}/view`,
    /** POST /api/reports/generate/:id — generate & upload report */
    generate: (id: number | string) => `api/reports/generate/${id}`,
    /** Proxy URL used in the iframe src */
    viewUrl: (id: number | string) => `api/reports/${id}/view/index.html`,
  },

  ANALYTICS_V2: {
    kpiCatalog: "api/analytics-v2/kpi-catalog",
    kpiTargets: "api/analytics-v2/kpi-targets",
    narrative: "api/analytics-v2/narrative",
    scorecard: "api/analytics-v2/scorecard",
    trends: "api/analytics-v2/trends",
    cycleRunStatusSummary: "api/analytics-v2/cycle-run-status-summary",
    cyclePassFailPercentTrend: "api/analytics-v2/cycle-pass-fail-percent-trend",
    passFailSummary: "api/analytics-v2/pass-fail-summary",
    latestCycleRuns: "api/analytics-v2/latest-cycle-runs",
    cycleRunCount: "api/analytics-v2/cycle-run-count",
    cycleExecutionAnalytics: "api/analytics-v2/cycle-execution-analytics",
    executionDurationTrend: "api/analytics-v2/execution-duration-trend",
    defectFlowTrend: "api/analytics-v2/defect-flow-trend",
    topFailingTestsByUser: "api/analytics-v2/top-failing-tests-by-user",
    testHealthSnapshot: "api/analytics-v2/test-health-snapshot",
    errorStatistics: "api/analytics-v2/error-statistics",
    newTestsPerUser: "api/analytics-v2/new-tests-per-user",
    testsAuthoredVsExecuted: "api/analytics-v2/tests-authored-vs-executed",
    testCaseDistribution: "api/analytics-v2/test-case-distribution",
    workspaceTestCaseAuthorship: "api/analytics-v2/workspace-test-case-authorship",
    projectLevelCycleStats: "api/analytics-v2/project-level-cycle-stats",
    testCasesForReview: "api/analytics-v2/test-cases-for-review",
    releaseIntelligence: "api/analytics-v2/release-intelligence",
    compare: "api/analytics-v2/compare",
    automation: "api/analytics-v2/automation",
    quality: "api/analytics-v2/quality",
    environments: "api/analytics-v2/environments",
    environmentCoverage: "api/analytics-v2/environment-coverage",
    assetHealth: "api/analytics-v2/asset-health",
    team: "api/analytics-v2/team",
    explore: "api/analytics-v2/explore",
  },

  AI_ANALYTICS: {
    /** @deprecated Use SSE endpoint AI_ANALYTICS.stream instead */
    summary: "api/ai/analytics-summary",
    query: "api/ai/analytics-query",
    stream: "api/sse/analytics-stream",
  },

  BILLING: {
    plans: "api/billing/plans",
    subscription: "api/billing/subscription",
    usage: "api/billing/usage",
    checkoutSession: "api/billing/checkout-session",
    portalSession: "api/billing/portal-session",
    coupons: "api/billing/coupons",
    usageHistory: "api/billing/usage-history",
    usageDayDetail: (date: string) => `api/billing/usage-history/${date}/detail`,
  },

  GUIDE_ME: {
    previewStart: "api/guideme/preview/start",
    previewEnd: "api/guideme/preview/end",
    previewStatus: "api/guideme/preview/status",
  },
};

export default API_ENDPOINTS;
